





















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { InventoryQueryParams } from '@/interface/store/inventory';

const namespace: string = 'profile';

@Component
export default class Profile extends Vue {
  @Action('getProfile', { namespace }) c_getProfile!: any;

  @Getter('getterQueryParams', { namespace: 'inventory' })
  readonly c_getterInventoryQueryParams!: InventoryQueryParams;
  @Getter('getterLastGroupId') c_getterLastGroupId!: string;
  @Getter('getterAuthUserId', { namespace: 'auth' }) c_getterAuthUserId!: string;
  @Getter('getterUser', { namespace }) c_getterUser!: {
    id: string;
    fullName: string;
    email: string;
    phoneNumber: string;
    organization: string;
    position: string;
    lastGroupId: string | null;
  };
  public activeName: any = null;

  async created() {
    try {
      await this.c_getProfile(this.c_getterAuthUserId);
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  @Watch('$route', { immediate: true, deep: true })
  onRouteChange(val: any, oldVal: any) {
    this.activeName = val.name;
  }

  routeToBack() {
    this.$router.go(-1);
  }

  routeToClose() {
    this.$router.push(`/groups`);
  }

  handleClick(tab: any, event: any) {
    this.$router.push({
      name: this.activeName,
    });
  }
}
